import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSolidifierClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 120,
	viewBox: "0 0 80.0 120.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 10.0 L 0.0 80.0 L 40.0 120.0 L 80.0 80.0 L 80.0 10.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 30.0 L 10.0 30.0 L 10.0 20.0 M 70.0 20.0 L 70.0 30.0 L 80.0 30.0 M 10.0 70.0 L 40.0 100.0 L 70.0 70.0 M 40.0 0.0 L 40.0 100.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgSolidifierClosed;
